import { makeStyles, tokens } from "@fluentui/react-components";

export const useHomeAppStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    height: "100%",
    alignItems: "flex-start",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: tokens.colorNeutralBackground2,
    position: "relative",
    paddingTop: "75px",
  },
  fullAppView: {
    paddingTop: "5%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  appGridTitle: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase500,
    padding: "0 5px",
  },
});
